<nav
  id="navbar-main"
  class="navbar navbar-horizontal navbar-transparent navbar-main navbar-expand-lg navbar-light font-bricolage"
  style="
    position: absolute;
    z-index: 100;
    top: 0;
    width: 100%;
    border: 0;
    background-color: #444444;
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(10px);
    box-shadow: none;
    font-family: 'Poppins', sans-serif;
    color: white;
  "
>
  <div class="container">
    <a class="navbar-brand" [routerLink]="['/home']">
      <img src="assets/img/brand/white.png" />
    </a>
    <button
      class="navbar-toggler"
      type="button"
      aria-label="Toggle navigation"
      (click)="toggleNav()"
      [attr.aria-expanded]="!isCollapsed"
      aria-controls="collapseBasic"
    >
      <iconify-icon icon="mdi:menu" width="26" height="26" style="color: white;"></iconify-icon>
    </button>

    <div
      class="navbar-collapse navbar-custom-collapse"
      id="collapseBasic"
      [class.nav-open]="!isCollapsed"
    >
      <div class="navbar-collapse-header">
        <a [routerLink]="['/home']" class="collapse-brand">
          <img src="assets/img/brand/white.png" />
        </a>
        <button
          type="button"
          class="nav-close-btn"
          aria-label="Toggle navigation"
          (click)="toggleNav()"
        >
          <iconify-icon icon="mynaui:letter-x-solid" width="40" height="40"></iconify-icon>
        </button>
      </div>

      <ul class="navbar-nav mr-auto mobile-nav-list" #navList>
        <li class="nav-item d-flex d-lg-none" *ngIf="isLoggedIn">
          <a
            class="nav-link"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLink]="['/transactions/transaction-list']"
          >
            <iconify-icon   class="mobile-nav-icon slide-item" icon="ic:twotone-dashboard" width="35" height="35"></iconify-icon>
            <span class="nav-link-inner--text slide-item">Dashboard</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLink]="['/home']"
          >
            <iconify-icon   class="mobile-nav-icon slide-item" icon="ion:home" width="35" height="35"></iconify-icon>
            <span class="nav-link-inner--text slide-item">Home</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            routerLinkActive="active"
            [routerLink]="['/features/services']"
          >
            <iconify-icon   class="mobile-nav-icon slide-item" icon="ic:outline-miscellaneous-services" width="35" height="35"></iconify-icon>
            <span class="nav-link-inner--text slide-item">Services</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            routerLinkActive="active"
            [routerLink]="['/features/about']"
          >
            <iconify-icon   class="mobile-nav-icon slide-item" icon="mdi:about" width="35" height="35"></iconify-icon>
            <span class="nav-link-inner--text slide-item">About Us</span>
          </a>
        </li>
        <!-- Tempo remove for production deployment (uncomment when our partners page is ready to be deployed) -->
        <!-- <li class="nav-item" *ngIf="!isLoggedIn">
          <a
            class="nav-link"
            routerLinkActive="active"
            [routerLink]="['/features/our-partners']"
          >
            <iconify-icon   class="mobile-nav-icon slide-item" icon="mdi:handshake-outline" width="35" height="35"></iconify-icon>
            <span class="nav-link-inner--text slide-item">Our Partners</span>
          </a>
        </li> -->
        <li class="nav-item">
          <a
            class="nav-link"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLink]="['/features/user-guide']"
          >
            <iconify-icon   class="mobile-nav-icon slide-item" icon="material-symbols:developer-guide-outline-rounded" width="35" height="35"></iconify-icon>
            <span class="nav-link-inner--text slide-item">User Guide</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            routerLinkActive="active"
            [routerLink]="['/features/contact-us']"
          >
            <iconify-icon   class="mobile-nav-icon slide-item" icon="ix:support" width="35" height="35"></iconify-icon>
            <span class="nav-link-inner--text slide-item">Contact Us</span>
          </a>
        </li>
        <li class="nav-item d-lg-none" *ngIf="isLoggedIn || (router.url !== '/features/login')">
          <a
            class="nav-link"
            *ngIf="!isLoggedIn && router.url !== '/features/login'"
            [routerLink]="['/features/login']"
          >
            <iconify-icon   class="mobile-nav-icon slide-item" icon="mdi:login" width="35" height="35"></iconify-icon>
            <span class="nav-link-inner--text slide-item">Login</span>
          </a>
          <a
            class="nav-link"
            *ngIf="isLoggedIn"
            href="javascript:void(0)"
            (click)="onLogout()"
          >
            <iconify-icon  class="mobile-nav-icon slide-item" icon="solar:running-bold" width="35" height="35"></iconify-icon>
            <span class="nav-link-inner--text slide-item">Log Out</span>
          </a>
        </li>
      </ul>

      <ul class="navbar-nav ml-auto align-items-center">

        <!-- NOT logged in: desktop only login button -->
        <a
          *ngIf="!isLoggedIn && router.url !== '/features/login'"
          class="nav-link login-btn d-none d-lg-flex"
          routerLinkActive="active"
          [routerLink]="['/features/login']"
        >
          <span class="nav-link-inner--text">Login</span>
        </a>

        <!-- Logged in: avatar dropdown — DESKTOP ONLY -->
        <li
          class="nav-item dropdown d-none d-lg-flex align-items-center"
          *ngIf="isLoggedIn"
          dropdown
          placement="bottom-right"
          [isOpen]="showProfileModal"
          (isOpenChange)="onProfileDropdownToggle($event)"
        >
          <a class="nav-link pr-0" role="button" dropdownToggle style="cursor: pointer;">
            <span class="avatar avatar-sm rounded-circle" style="overflow:hidden; display:inline-flex; vertical-align:middle;">
              <img
                alt="Image placeholder"
                [src]="profilePhotoUrl || 'assets/img/theme/no-profile-placeholder.png'"
                style="width:100%; height:100%; object-fit:cover; border-radius:50%;"
              />
            </span>
          </a>
          <div
            class="dropdown-menu dropdown-menu-arrow dropdown-menu-right"
            *dropdownMenu
            style="width: min(400px, 95vw); min-width: 0; padding: 0; overflow: hidden; border-radius: 12px;"
            (click)="$event.stopPropagation()"
          >
            <app-profile-photo-modal
              *ngIf="showProfileModal"
              [profilePhotoUrl]="profilePhotoUrl"
              (closed)="onProfileDropdownToggle(false)"
              (photoUpdated)="onPhotoUpdated($event)">
            </app-profile-photo-modal>
          </div>
        </li>

        <li
          class="nav-item dropdown d-none d-lg-flex align-items-center"
          *ngIf="isLoggedIn"
          dropdown
          placement="bottom-right"
          [isOpen]="showUserDropdown"
          (isOpenChange)="onUserDropdownToggle($event)"
        >
          <a class="nav-link pl-2 pr-0" role="button" dropdownToggle style="cursor: pointer;">
            <span class="mb-0 text-sm font-weight-bold">{{ username }}</span>
          </a>
          <div class="dropdown-menu dropdown-menu-arrow dropdown-menu-right" *dropdownMenu>
            <a [routerLink]="['/transactions/transaction-list']" routerLinkActive="active" class="dropdown-item">
              <i class="fas fa-th-large"></i>
              <span>Dashboard</span>
            </a>
            <a [routerLink]="['/features/user-guide']" routerLinkActive="active" class="dropdown-item">
              <i class="fas fa-book"></i>
              <span> User Guide</span>
            </a>
            <a [routerLink]="['/features/timeline']" routerLinkActive="active" class="dropdown-item">
              <i class="ni ni-settings-gear-65"></i>
              <span>Settings</span>
            </a>
            <a href="javascript:void(0)" (click)="openChangePasswordModal()" class="dropdown-item">
                <span style="display: inline-flex; align-items: center; width: 1.25rem; margin-right: 0.5rem;">
                    <iconify-icon icon="material-symbols:key" width="16" height="16"></iconify-icon>
                </span>
                <span>Change Password</span>
            </a>
            <div class="dropdown-divider"></div>
            <a href="javascript:void(0)" (click)="onLogout()" class="dropdown-item">
              <i class="ni ni-user-run"></i>
              <span>Logout</span>
            </a>
          </div>
        </li>

      </ul>

    </div>
  </div>
</nav>